import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import PhoneInput from '../components/PhoneInput';
import './AuthPage.css';

export default function RequestAccessPage() {
  const [form, setForm] = useState({ nom: '', prenom: '', email: '', password: '', societe: '', telephone: '', user_type: 'individual' });
  const [showPassword, setShowPassword] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/request-access', form);
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Submission failed');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo"><img src="/logo.png" alt="The Daily Bid" style={{ height: 75 }} /></div>
          <p style={{ textAlign: 'center', marginTop: 16, lineHeight: 1.8 }}>
            Your request has been received.<br />
            Once approved, you will be able to log in with your email and the password you just created.
          </p>
          <Link to="/login" className="btn btn-outline" style={{ marginTop: 24, width: '100%', display: 'block', textAlign: 'center' }}>Back to login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo"><img src="/logo.png" alt="The Daily Bid" style={{ height: 75 }} /></div>
        <p className="auth-sub">Request platform access</p>
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label>First name</label>
              <input className="input" value={form.prenom} onChange={e => setForm(f => ({ ...f, prenom: e.target.value }))} required />
            </div>
            <div className="form-group">
              <label>Last name</label>
              <input className="input" value={form.nom} onChange={e => setForm(f => ({ ...f, nom: e.target.value }))} required />
            </div>
          </div>
          <div className="form-group">
            <label>Email</label>
            <input className="input" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
          </div>
          <div className="form-group">
            <label>Password</label>
            <div className="password-wrapper">
              <input className="input" type={showPassword ? 'text' : 'password'} value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required minLength={8} placeholder="Minimum 8 characters" />
              <button type="button" className="password-toggle" onClick={() => setShowPassword(s => !s)}>{showPassword ? <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg> : <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/><path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>}</button>
            </div>
          </div>
          <div className="form-group">
            <label>Account type</label>
            <div style={{ display: 'flex', gap: 16, marginTop: 4 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                <input type="radio" name="user_type" value="individual" checked={form.user_type === 'individual'} onChange={() => setForm(f => ({ ...f, user_type: 'individual' }))} />
                Individual
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                <input type="radio" name="user_type" value="professional" checked={form.user_type === 'professional'} onChange={() => setForm(f => ({ ...f, user_type: 'professional' }))} />
                Professional
              </label>
            </div>
          </div>
          <div className="form-group">
            <label>Company {form.user_type === 'individual' ? '(optional)' : ''}</label>
            <input className="input" value={form.societe} onChange={e => setForm(f => ({ ...f, societe: e.target.value }))} required={form.user_type === 'professional'} />
          </div>
          <div className="form-group">
            <label>Phone (optional)</label>
            <PhoneInput value={form.telephone} onChange={val => setForm(f => ({ ...f, telephone: val }))} />
          </div>
          {error && <div className="error-msg">{error}</div>}
          <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%', marginTop: 16 }}>
            {loading ? <span className="spinner" /> : 'Submit request'}
          </button>
        </form>
        <p className="auth-footer"><Link to="/login">Back to login</Link></p>
      </div>
    </div>
  );
}
